export default "__VITE_ASSET__BtHmC7gR__"